import { ConnectionService } from '@services/connection-service';
import { inject, Injectable } from '@angular/core';
import { ExperimentService } from '@services/experiment/experiment.service';
import { Onboarding, OnboardingProfileBreakdownConfig } from './onboarding';

@Injectable({
  providedIn: 'root',
})
export class OnboardingService {
  private connectionService: Record<string, any> = inject(ConnectionService);
  private readonly experimentService: ExperimentService = inject(ExperimentService);

  /** Callers must `await experimentService.experimentsLoaded` first, or the split flow reads as off. */
  getService(): Onboarding {
    const user = this.connectionService.getActingUser();
    const isUserWithoutMainConcern = this.connectionService.userWithoutPrivateMainConcern();
    const profileBreakdown: OnboardingProfileBreakdownConfig = {
      enabled: this.experimentService.isUserProfileInputBreakdownEnabled(),
      skipAgePage: this.experimentService.shouldSkipAgePage(),
    };

    return new Onboarding(JSON.parse(JSON.stringify(user)), isUserWithoutMainConcern, profileBreakdown);
  }
}
